import { Leaf, PanelsTopLeft, Cpu, BatteryCharging, Wrench, Sparkles } from "lucide-react";
import { BRAND, NAV } from "@/data/site";
import { scrollToId, useLang } from "./common";

const STRIP = [PanelsTopLeft, Cpu, BatteryCharging, Wrench];

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-[#0F295B] text-white relative overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 pt-20 pb-10">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="inline-block rounded-2xl bg-white p-3"><img src="/assets/logo-sm.png" alt="Vivan Energia" className="h-14 w-auto" /></div>
            <p className="mt-6 text-slate-300 max-w-sm">{t.footer.desc}</p>
            <p className="mt-6 text-sm text-slate-300">{t.footer.regards} <span className="text-white font-semibold">{BRAND.name}</span> — {BRAND.proprietor} {t.footer.role}</p>
          </div>
          <div className="lg:col-span-3">
            <p className="font-mono2 text-xs tracking-[0.2em] uppercase text-[#F39C12] mb-5">{t.footer.explore}</p>
            <ul className="space-y-2">
              {NAV.map((n, i) => (
                <li key={n.id}><button data-testid={`footer-nav-${n.id}`} onClick={() => scrollToId(n.id)} className="text-slate-200 hover:text-[#00A651] transition-colors">{t.nav[i]}</button></li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-4 space-y-3 text-slate-200">
            <p className="font-mono2 text-xs tracking-[0.2em] uppercase text-[#F39C12] mb-5">{t.footer.reach}</p>
            <p>{BRAND.address}</p>
            <p>{BRAND.phones.map((p, i) => <a key={p} href={`tel:${p.replace(/\s/g, "")}`} className="hover:text-[#00A651]">{p}{i === 0 ? " / " : ""}</a>)}</p>
            <p><a href={`mailto:${BRAND.email}`} className="hover:text-[#00A651]">{BRAND.email}</a></p>
            <p data-testid="footer-gstin" className="inline-block mt-2 rounded-full bg-[#F39C12] text-[#0F295B] font-bold px-4 py-1.5 font-mono2 text-sm">GSTIN: {BRAND.gstin}</p>
          </div>
        </div>
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-3">
          {t.footer.strip.map((s, i) => {
            const I = STRIP[i];
            return (
              <div key={s} className="flex items-center gap-3 rounded-2xl border border-white/10 px-4 py-3"><I className="w-5 h-5 text-[#00A651]" /><span className="text-sm">{s}</span></div>
            );
          })}
        </div>
        <div className="relative mt-16" aria-hidden="true">
          <div className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[70%] h-[150%] rounded-full bg-[radial-gradient(ellipse_at_center,rgba(243,156,18,0.5),rgba(243,156,18,0.18)_45%,transparent_72%)] blur-2xl" />
          <p className="relative font-display font-bold text-[10.5vw] xl:text-[150px] leading-[0.85] tracking-[-0.04em] text-white/[0.1] select-none whitespace-nowrap">VIVAN ENERGIA</p>
        </div>
        <div className="mt-6 flex flex-col md:flex-row gap-3 justify-between text-xs text-slate-300 border-t border-white/10 pt-6">
          <p className="flex items-center gap-2 tracking-[0.25em] uppercase"><Leaf className="w-4 h-4 text-[#00A651]" /> {t.footer.tagline}</p>
          <p className="flex items-center gap-1.5">
            <Sparkles className="w-3.5 h-3.5 text-[#F39C12]" /> {t.footer.aiNote} · © {new Date().getFullYear()} Vivan Energia. {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
};
